import { render, staticRenderFns } from "./FuneralDirector.vue?vue&type=template&id=f1a73124&scoped=true&"
import script from "./FuneralDirector.vue?vue&type=script&lang=js&"
export * from "./FuneralDirector.vue?vue&type=script&lang=js&"
import style0 from "./FuneralDirector.vue?vue&type=style&index=0&id=f1a73124&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a73124",
  null
  
)

export default component.exports